module.exports = nxrmUiPlugin;